import { render, staticRenderFns } from "./SalonProcessBox.vue?vue&type=template&id=84b7bd58&scoped=true&"
import script from "./SalonProcessBox.vue?vue&type=script&lang=js&"
export * from "./SalonProcessBox.vue?vue&type=script&lang=js&"
import style0 from "./SalonProcessBox.vue?vue&type=style&index=0&id=84b7bd58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b7bd58",
  null
  
)

export default component.exports